import React, { useContext, useState } from 'react';
import { AudioContext } from '../../libs/audio-provider';
import Modal from '../ui/Modal';
import SvgButton from '../ui/SvgButton';

interface GamePrintingDescriptionProps {
  children?: React.ReactNode;
  style?: React.CSSProperties;
  onFinish: () => void;
}

const StatusMap = {
  '': { className: '', message: null, next: '' },
  'message-1': { className: 'message', message: '印刷術始於隋唐時期，<br/>起初人們利用摹拓原理的雕版印刷。<br/>但由於雕版印刷是一頁一塊木板，<br/>刻錯了便需要重刻新一塊木板，成本高昂。<br/>後來宋代畢昇發明了活字印刷術，<br/>以膠泥取代木板，一泥一字，用火燒成。<br/>印刷時文字可自由調動，靈活及便宜。<br/>', next: 'message-2' },
  'message-2': { className: 'message-western', message: '這種印刷術真的很方便，我長知識了！', next: 'message-3' },
  'message-3': { className: 'message', message: '現在就讓你試試吧！', next: '' },
}

function GamePrintingDescription(props: GamePrintingDescriptionProps) {
  const { playClick } = useContext(AudioContext);
  const [status, setStatus] = useState<'message-1' | 'message-2' | 'message-3'| ''>('message-1');

  const ShowModal = () => {
    return <div className={`modal modal-game-printing game-${StatusMap[status].className}`}>
      <button className="button modal-button-close" onClick={() => { playClick(); setStatus(''); props.onFinish(); }}>
        <SvgButton prefix={`${process.env.PUBLIC_URL}/assets/game-printing/close-button`} src1=".svg" src2="-select.svg" alt="關閉"></SvgButton>
      </button>
      <div className="modal-content">
        {null !== StatusMap[status].message ? <p className="message" dangerouslySetInnerHTML={{ __html: StatusMap[status].message as string }}></p> : null}
      </div>
      <button className="button modal-button-next" onClick={() => {
        playClick();
        setStatus(StatusMap[status].next as any);
        if ('' === StatusMap[status].next) {
          props.onFinish();
        }
      }}>
        <SvgButton prefix={`${process.env.PUBLIC_URL}/assets/game-printing/game3-next-button`} src1=".svg" src2="-select.svg" alt="下一頁"></SvgButton>
      </button>
    </div>
  }

  return (
    <>
      {'' !== status
        ? <Modal>
          <ShowModal />
        </Modal>
        : null}
    </>
  )
}

export default GamePrintingDescription;
